import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsMlpZatapomponent extends Component {
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='invalidMessage' @type='text-editor' />
            <fieldset.field @property='modelIds' @type='string-array' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
        </div>
      </div>
    </Form>
  </template>
}
